import React from 'react'

import { MetaLayout } from 'components'
import ServiceListPage from 'views/serviceList/ServiceListPage'
import {
  fetchRegions,
  businessListUrlGenerator,
  fetchBusinessList
} from '../../api'
import { Layout } from '../../components'
import { SWRConfig } from 'swr'

const Index = ({ title, description, initialData, regions }) => {
  return (
    <MetaLayout title={title} description={description}>
      <SWRConfig value={{ fallback: initialData }}>
        <ServiceListPage regions={regions} />
      </SWRConfig>
    </MetaLayout>
  )
}

Index.getLayout = function getLayout(page) {
  return <Layout>{page}</Layout>
}

export async function getServerSideProps({ query, req }) {
  const latitude = req.cookies?.latitude
  const longitude = req.cookies?.longitude
  const regionId = query?.index[0] ? query?.index[0] : undefined
  const serviceId = query?.index[1] ? query?.index[1] : undefined

  const businessListUrl = businessListUrlGenerator({
    regionId,
    serviceId,
    isGeolocationUsed: !!latitude
  })
  const restaurantsData = await fetchBusinessList({
    regionId,
    serviceId,
    latitude,
    longitude
  })

  const { data } = await fetchRegions()
  const regions = data?.regions ?? []

  const foundRegion = regions.find((region) => region.slug === regionId) ?? {}

  const foundService = foundRegion?.services?.find(
    (service) => service.slug === serviceId
  )

  const title =
    (foundService ? foundService?.seo_title : foundRegion?.seo_title) ?? ''

  const description =
    (foundService
      ? foundService?.seo_description
      : foundRegion?.seo_description) ?? ''

  return {
    props: {
      initialData: {
        [businessListUrl]: restaurantsData,
        '/selected-region': foundRegion
      },
      regions,
      title,
      description
    }
  }
}

export default Index
